import * as domHelpers from "../../scripts/utils/domHelpers";

class EditTickets {
    constructor() {
        this.wrapHeader();

        const changeSeatsButton = document.getElementById(
            "ctl00_ContentPlaceHolder_ChangeMySeatsLink",
        );

        if (changeSeatsButton) {
            const buttons = document.querySelector(".Buttons");

            buttons.prepend(changeSeatsButton);
        }
    }

    wrapHeader() {
        const headerElements = document.querySelectorAll(".EditTicketsHeading");

        domHelpers.wrapAll(headerElements, {
            element: "div",
            className: "spektrix-page-header",
        });
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const pageSelector = document.querySelector(".SpektrixPage.EditTickets");

    if (pageSelector) {
        new EditTickets();
    }
});
